<div class="cooking-container">
  <div class="cooking-header" (swipedown)="backToList()">
    <div class="title">
      <img src="assets/plans/edit-blue.svg" alt="" />

      <p>ویرایش</p>
    </div>
    <img
      src="assets/cookingbook/angle-down.svg"
      (click)="backToList()"
      alt=""
    />
  </div>
  <div class="cooking-body edit">
    <div class="add-food-bottomsheet-input-holder cooking-holder">
      <p class="cooking-unit-text">نام غذا</p>
      <input type="text" [(ngModel)]="name" disabled />
    </div>
    <div class="twin-input">
      <div style="margin-top: 45px">
        <p class="cooking-unit-text">میزان</p>
        <input type="tel" (input)="checkValid()" [(ngModel)]="amount" />
      </div>
      <div style="margin-top: 45px">
        <p class="cooking-unit-text">واحد</p>
        <input
          type="text"
          (input)="checkValid()"
          [(ngModel)]="unitDescription"
        />
      </div>
    </div>
    <div
      class="add-food-bottomsheet-input-holder cooking-holder"
      style="margin-top: 45px"
    >
      <p class="cooking-unit-text">توضیحات</p>
      <input type="text" (input)="checkValid()" [(ngModel)]="description" />
    </div>
  </div>
  <div class="submit-button" (click)="submit()" [ngClass]="{active}">ثبت</div>
</div>
